import React from 'react';

import { ValueBox, ValueGroup, ValueToggle } from '@candu-ai/craft/ui';
import { CRAFT_ROOT_ID } from 'craft/constants';
import { Section } from 'craft/containers/Toolbox/components';
import { useMultiNodes } from 'craft/hooks';

export const HotspotGroupSettings = () => {
  const {
    props,
    actions: { setProps },
  } = useMultiNodes([CRAFT_ROOT_ID]);

  // eslint-disable-next-line react/prop-types
  const shouldOpenFirst = props?.shouldOpenFirst?.value || false;

  return (
    <Section name="Hotspot Group Settings">
      <ValueGroup>
        <ValueBox label="Open first Hotspot on load">
          <ValueToggle
            isActive={shouldOpenFirst}
            onClick={() => setProps({ shouldOpenFirst: !shouldOpenFirst })}
          />
        </ValueBox>
      </ValueGroup>
    </Section>
  );
};
